import { gsap } from 'gsap';

export default class {

	constructor(options) {

		// OPTIONS
		this.defaults = {

			$el: undefined,

			arrows: false,
			autoplay: true,
			pauseOnHover: true,
			default_index: 0,
			time_t_on: 1,
			time_t_off: 0.6,
			time_between_slides: 3000

		}

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace  = 'slideshow_simple';

		// DOM ELEMENT !!!!!!!!!!
		this.$el = this.options.$el;

		// init!!!!
		if ( this.$el.length > 0 ){
			this.init();
		}

	}

	init(){

		// vars
		this.$win = $(window);
		this.$doc = $(document);
		this.$html = $('html');
		this.$body = $( 'body' );
		this.touch = !$('html').hasClass('no-touch');
		this.slides = [];

		this.index = this.options.default_index;
		this.prev_index = -1;
		this.timeout = -1;
		this.running = false;
		this.over = false;

		this.initSlider( true );
		this.addEvents( true );
	}

	initSlider( b ){
		if ( b ){

			this.$el.find( '.slide-simple' ).each( (i, el ) => {
				this.slides[i] = $(el);
				if ( this.options.fade ){
					this.slides[i].css({
						opacity: 0
					});
				}
			} );
			if ( this.slides.length > 0 ){
				setTimeout( () => {
						this.setSlide( this.index );
				}, 17);
			}
		}
	}

	setSlide( i ){
		let $s, tl, $n;

		this.running = true;

		if ( this.prev_index !== -1 ){

			$s = this.slides[this.prev_index];

			tl = gsap.timeline({});

			$s.css({
					'z-index': this.slides.length + 1
			});
			$n    = this.slides[ i ];
			$n.css({
				'z-index': this.slides.length + 2
			});
			// fade out 
			tl.fromTo( $s, {opacity:1},{opacity:0, ease:'power2.out',duration:this.options.time_t_off});

			// fade in
			tl.fromTo( $n, {opacity:0},{opacity:1, ease:'power2.out',duration:this.options.time_t_on,
				onComplete: () => {
					this.onSetSlide();
				}
			}, "-="+this.options.time_t_off/4);

		}
		else{

			// first slide 
			$s    = this.slides[ i ];

			$s.css({
				'z-index': this.slides.length + 2
			});
			gsap.fromTo( $s, {opacity:0},{opacity:1,duration:this.options.time_t_on,ease:'power.out',delay:0,
				onComplete: () => {
					this.onSetSlide();
				}
			});

		}

	}

	onSetSlide(){
		this.running = false;
		this.setAutoPlay();
	}

	setAutoPlay(){
		if ( this.options.pauseOnHover ){
			if ( this.over ){
				return;
			}
		}
		if ( this.options.autoplay ){
			clearTimeout( this.timeout );
			this.timeout = setTimeout( () => {
				this.setNextSlide();
			}, this.options.time_between_slides );
		}
	}

	setNextSlide(){
		if ( this.running ){
			return;
		}
		clearTimeout( this.timeout );
		this.prev_index = this.index;
		this.index += 1;
		if ( this.index >= this.slides.length ){
			this.index = 0;
		}
		this.setSlide( this.index );
	}

	setPrevSlide(){
		if ( this.running ){
			return;
		}
		clearTimeout( this.timeout );
		this.prev_index = this.index;
		this.index -= 1;
		if ( this.index < 0 ){
			this.index = this.slides.length - 1;
		}
		this.setSlide( this.index );
	}

	addEvents( b ){
		if ( b ){
			this.$el.on( 'mouseenter', () => {
				this.over = true;
				if ( this.options.autoplay && this.options.pauseOnHover ){
					clearTimeout( this.timeout );
				}
			});
			this.$el.on( 'mouseleave', () => {
				this.over = false;
				if ( this.options.autoplay && this.options.pauseOnHover ){
					if ( this.running ){
						//this.setAutoPlay();
					}
					else{
						//this.setNextSlide();
						this.setAutoPlay();
					}
				}
			});
		}
		else{
			this.$el.off( 'mouseenter' );
			this.$el.off( 'mouseleave' );

		}
	}

	// public methods //////////////////////////////////////////////////////////////////////////
	destroy(){
		this.initSlider( false );
		this.addEvents( false );
	}

}
